import { jsx } from 'react/jsx-runtime';
import { Flex } from './Flex.js';
import { cssVar } from '../theme/variables.js';
import { styled } from 'styled-components';
import { isString } from '@fabric-app/utils/guards';
import { IconEnter } from '@fabric-app/icons/old';
import { mediaMobile } from '../constants/styled-utils.js';
import { hasMacOSKbd } from '@fabric-app/utils/detection';

const KbdBase = styled.kbd.withConfig({
  displayName: "Kbd__KbdBase",
  componentId: "sc-4d11834c-0"
})([
  `font-family:'Inter',sans-serif;text-transform:uppercase;font-weight:600;font-size:`,
  `px;line-height:12px;display:flex;align-items:center;justify-content:center;gap:3px;border-radius:4px;padding:0 4px;height:21px;min-width:21px;background:`,
  `;color:`,
  `;`,
  `{display:none;}`
], (p) => isString(p.children) && p.children === "⌘" ? 14 : 10, cssVar["color-bg-tertiary"], cssVar["color-text-secondary"], ({ allowMobile = false }) => !allowMobile && mediaMobile);
const IconEsc = styled.span.attrs({
  children: "esc"
}).withConfig({
  displayName: "Kbd__IconEsc",
  componentId: "sc-4d11834c-1"
})([
  ``
]);
const KbdCmdOrCtrl = () => {
  const macKeyboard = hasMacOSKbd();
  return /* @__PURE__ */ jsx(Kbd, {
    style: {
      fontSize: macKeyboard ? 14 : 10
    },
    children: macKeyboard ? "⌘" : "Ctrl"
  });
};
const Group = styled(Flex).attrs({
  alignItems: "center",
  gap: "text"
}).withConfig({
  displayName: "Kbd__Group",
  componentId: "sc-4d11834c-2"
})([
  ``,
  `{display:none;}`
], ({ allowMobile = false }) => !allowMobile && mediaMobile);
const Kbd = Object.assign(KbdBase, {
  IconEnter,
  IconEsc,
  KbdCmdOrCtrl,
  Group
});

export { Kbd };
//# sourceMappingURL=Kbd.js.map
